export default "__VITE_PUBLIC_ASSET__6f80b45b__"